import { organisationConstants } from '../../_constants/organisation.constants';
const initialState = { set_report_theme_loading : true, set_report_theme: '', set_report_theme_error: false};

export function setReportTheme(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_SET_REPORT_THEME:
        return {
            set_report_theme_loading: true,
            set_report_theme: '',
            set_report_theme_error: false
        };
      case organisationConstants.RESPONSE_SET_REPORT_THEME:
        return {
            set_report_theme_loading: false,
            set_report_theme: action.set_report_theme,
            set_report_theme_error: false
        };
      case organisationConstants.ERROR_SET_REPORT_THEME:
        return { 
            set_report_theme_loading: false,
            set_report_theme: '',
            set_report_theme_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/setReportTheme.reducer.js